<script lang="ts">
    
    import { onDestroy } from "svelte";
    import type { FigureName } from "../../global";

    export let checkers: FigureName[];

    let numIterations: number;
    let iterationIndex = -1;
    let animationName = '';
    let nextTimeout: number;

    $: setupStack(checkers);

    onDestroy(() => {
        window.clearTimeout(nextTimeout);
    });

    function setupStack(checkers: FigureName[]): void {
        numIterations =  checkers.length * 3;
        iterationIndex = -1;
        nextAnimation();
    }

    function nextAnimation(): void {
        iterationIndex++;
        if (iterationIndex === numIterations) {
            animationName = '';
            return;
        }
        window.clearTimeout(nextTimeout);
        nextTimeout = window.setTimeout(nextAnimation, 3000);
        animationName = `check-${checkers[iterationIndex % checkers.length]}`;
    }

</script>

<div class="check {animationName}">
    <div class="cell"></div>
    <div class="cell"></div>
    <div class="cell"></div>
    <div class="cell"></div>
    <div class="cell"></div>
    <div class="cell"></div>
    <div class="cell"></div>
    <div class="cell"></div>
    <div class="cell"></div>
</div>

<style lang="scss">

    .check {
        display: grid;
        gap: 0.2rem;
        grid-template-columns: repeat(3, 1rem);
        grid-template-rows: repeat(3, 1rem);
    }

    .cell {
        background-color: var(--color-primary);
        transition-property: background-color;
        transition-duration: 500ms;
    }

    .check-line {

        .cell:nth-child(4),
        .cell:nth-child(5),
        .cell:nth-child(6) {
            background-color: var(--color-secondary);
        }

    }

    .check-column {

        .cell:nth-child(2),
        .cell:nth-child(5),
        .cell:nth-child(8) {
            background-color: var(--color-secondary);
        }

    }

    .check-diagonal {

        .cell:nth-child(1),
        .cell:nth-child(5),
        .cell:nth-child(9) {
            background-color: var(--color-secondary);
        }

    }

    .check-corners {

        .cell:nth-child(1),
        .cell:nth-child(3),
        .cell:nth-child(7),
        .cell:nth-child(9) {
            background-color: var(--color-secondary);
        }

    }

</style>
